module.exports = __webpack_public_path__ + "static/media/five-star-reflexology.2ab8a451.webp";